module.exports = __webpack_public_path__ + "img/17885fb.jpg";